/**
 * Report_Delivered_Time is stamped when the report is submitted, so only these two statuses can
 * carry one: both are derived from a score or comments being present, and differ only on whether
 * the interview video URL is set.
 */
export const REPORT_DELIVERED_STATUSES = ['Completed', 'Missing Video'];

export const hasReportDeliveredTime = interviewStatus => REPORT_DELIVERED_STATUSES.includes(interviewStatus);
